/**
 * modalopenstatereducer.js
 * Created by calhosh on 10/22/2020.
 */

import initialState from './initialstate';
import * as types from '../actions/actiontypes';

export function modalOpenStateReducer(state = initialState.isModalOpen, action) {
	switch (action.type) {
		case types.SET_IS_MODAL_OPEN: {
			return action.isModalOpen;
		}
		default:
			return state;
	}
}

export function modalLevelStateReducer(state = initialState.modalLevel, action) {
	switch (action.type) {
		case types.SET_MODAL_LEVEL: {
			return action.modalLevel;
		}
		default:
			return state;
	}
}

export function adcModalOpenStateReducer(state = initialState.isADCModalOpen, action) {
	switch (action.type) {
		case types.SET_IS_ADC_MODAL_OPEN: {
			return action.isADCModalOpen;
		}
		default:
			return state;
	}
}
